import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { API_BASE } from '../config/api';

function Article() {
  const { i18n } = useTranslation();
  const { slug } = useParams();
  const [article, setArticle] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    fetch(`${API_BASE}/api/articles`)
      .then(res => { if (!res.ok) throw new Error(); return res.json(); })
      .then(articles => {
        const found = articles.find(a => a.slug === slug);
        if (found) {
          setArticle(found);
        } else {
          setNotFound(true);
        }
        setLoading(false);
      })
      .catch(() => {
        // Fallback to static import if API unavailable
        import('../data/articles.json').then(m => {
          const found = m.default.find(a => a.slug === slug);
          if (found) {
            setArticle(found);
          } else {
            setNotFound(true);
          }
          setLoading(false);
        });
      });
  }, [slug]);

  if (loading) {
    return (
      <article className="page type-page status-publish hentry">
        <div className="entry-content"><p>Chargement...</p></div>
      </article>
    );
  }

  if (notFound || !article) {
    return (
      <article className="page type-page status-publish hentry">
        <header className="entry-header">
          <h1 className="entry-title">Article non trouvé</h1>
        </header>
        <div className="entry-content">
          <p>Désolé, cet article n'existe pas.</p>
          <Link to="/actualites" style={{ color: '#32afe5' }}>← Retour aux actualités</Link>
        </div>
      </article>
    );
  }

  const lang = i18n.language;
  const t = (lang && lang !== 'fr' && article.translations?.[lang]) || {};
  const title = t.title || article.title;
  const content = t.content || article.content;

  return (
    <article className="post type-post status-publish hentry">
      <header className="entry-header">
        <div style={{ marginBottom: '15px' }}>
          <Link
            to="/actualites"
            style={{
              color: '#32afe5',
              textDecoration: 'none',
              fontSize: '14px'
            }}
            onMouseEnter={(e) => e.currentTarget.style.textDecoration = 'underline'}
            onMouseLeave={(e) => e.currentTarget.style.textDecoration = 'none'}
          >
            ← Retour aux actualités
          </Link>
        </div>

        <div style={{
          fontSize: '12px',
          color: '#32afe5',
          textTransform: 'uppercase',
          marginBottom: '10px',
          fontWeight: 'bold'
        }}>
          {article.category}
        </div>

        <h1 className="entry-title">{title}</h1>

        {article.date && (
          <div className="entry-meta" style={{
            fontSize: '14px',
            color: '#888',
            marginTop: '10px'
          }}>
            Publié le{' '}
            <time dateTime={article.date}>
              {new Date(article.date).toLocaleDateString('fr-FR', {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
              })}
            </time>
          </div>
        )}
      </header>

      {article.featuredImage && (
        <div style={{
          margin: '30px 0',
          borderRadius: '8px',
          overflow: 'hidden'
        }}>
          <img
            src={article.featuredImage}
            alt={title}
            style={{
              width: '100%',
              height: 'auto',
              display: 'block'
            }}
          />
        </div>
      )}

      <div
        className="entry-content"
        dangerouslySetInnerHTML={{ __html: content }}
        style={{
          lineHeight: '1.8',
          fontSize: '16px'
        }}
      />

      <footer style={{
        marginTop: '40px',
        paddingTop: '20px',
        borderTop: '1px solid #e0e0e0'
      }}>
        <Link
          to="/actualites"
          style={{
            color: '#32afe5',
            textDecoration: 'none',
            fontSize: '14px',
            fontWeight: 'bold'
          }}
          onMouseEnter={(e) => e.currentTarget.style.textDecoration = 'underline'}
          onMouseLeave={(e) => e.currentTarget.style.textDecoration = 'none'}
        >
          ← Retour aux actualités
        </Link>
      </footer>
    </article>
  );
}

export default Article;
